/**
 * Portfolio Videos
 * School video showcase for the Schools page
 */

// Page content (editable via CMS)
export const videosContent = {
  hero: {
    headline: "Our School Videos",
    subtitle: "See our video production work for schools across Kent and SE England",
  },
};

// Portfolio videos array (editable via CMS)
export const portfolioVideos = [
  {
    id: "st-gregorys",
    title: "St Gregory's Catholic School",
    youtube: "https://www.youtube.com/embed/16Rq56BbqFs?rel=0&modestbranding=1",
    thumb: "/images/social-media.webp",
  },
  {
    id: "holy-trinity-st-johns",
    title: "Holy Trinity & St John's",
    youtube: "https://www.youtube.com/embed/7PGNATbZx3c?rel=0&modestbranding=1",
    thumb: "/images/strategy.webp",
  },
  {
    id: "st-anthonys",
    title: "St Anthony's School",
    youtube: "https://www.youtube.com/embed/fl25cIohF3Y?rel=0&modestbranding=1",
    thumb: "/images/signage.webp",
  },
];
